import React, { useContext, useState } from "react"
import { Tab, Tabs } from "react-bootstrap";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import { JoinFull, QueryStats } from "@mui/icons-material";
import CombinationsTable from "./CombinationsTable";
import language from "../../nls/language.json";
import Context from "../../context/Context";
import ProductsTable from "./ProductsTable";
import PiecesTable from "./PiecesTable";
import './Combinations.css';

export default function Combinations() {
    const [idScreen, setIdScreen] = useState(1);

    const {
        selectedCountry,
    } = useContext(Context);

    const body = () => {
        switch (idScreen) {
            case 1:
                return <CombinationsTable />;
            case 2:
                return <ProductsTable />;
            case 3:
                return <PiecesTable />;
        }
    };

    const handleTitle = (icon, title) => {
        return (
            <div className="d-flex flex-column align-items-center">
                {icon}
                <span className="mt-1 text-light fw-bold">{title.toUpperCase()}</span>
            </div>
        )
    }

    const iconScaleDashboard = 1.3

    return (
        <>
            <Navbar />
            <Sidebar />
            <div className={`div-row-button dashboard-tabs`}>
                <Tabs
                    defaultActiveKey={1}
                    className="mb-1"
                    onSelect={(e) => setIdScreen(Number(e))}
                    fill
                >
                    <Tab
                        eventKey={1}
                        title={handleTitle(<JoinFull sx={{
                            transform: `scale(${iconScaleDashboard})`,
                            color: "#6aa84f"
                        }} />, language[selectedCountry.name].Cadastro.combinacoes.buttonsCombinacoes.combinacoes)}
                    />
                    <Tab
                        eventKey={2}
                        title={handleTitle(<QueryStats sx={{
                            transform: `scale(${iconScaleDashboard})`,
                            color: "#6aa84f"
                        }} />, language[selectedCountry.name].Cadastro.combinacoes.buttonsCombinacoes.produtos)}
                    />
                    <Tab
                        eventKey={3}
                        title={handleTitle(<QueryStats sx={{
                            transform: `scale(${iconScaleDashboard})`,
                            color: "#6aa84f"
                        }} />, language[selectedCountry.name].Cadastro.combinacoes.buttonsCombinacoes.pecas)}
                    />
                </Tabs>
            </div>
            <div
                className={`app_body`}
                style={{ padding: 0, top: 85 }}
            >
                <div style={{ marginBottom: 20 }}>{body()}</div>
            </div>
        </>
    )
}

